import { createSlice } from '@reduxjs/toolkit';
import { getAllHolidays, getHolidayDetail } from './actions';

const initialState = {
  data: [],
  selected: {},
  isLoading: false,
  isError: false,
  errorMessage: {}, // kalo retry setelah error, harus hapus errorMessage dan isError!
};

export const holidayCharge = createSlice({
  name: 'holidayCharge',
  initialState,
  reducers: {
    // reducers goes here
    resetSelectedHoliday: (state) => {
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllHolidays.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = [];
        state.isUpdateSuccess = false;
      })
      .addCase(getAllHolidays.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllHolidays.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getHolidayDetail.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.selected = {};
      })
      .addCase(getHolidayDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getHolidayDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selected = action.payload;
      });
  },
});

export const { resetSelectedHoliday } = holidayCharge.actions;

export default holidayCharge.reducer;
